import request from './request';

export function getPosttreatmentCheckLogs(params) {
  return request({
    url: '/fault-code-explanation-log',
    method: 'get',
    params: { ...params, call_type: 'posttreatment_check' }
  });
}

export function getPosttreatmentCheckLogById(id) {
  return request({
    url: `/fault-code-explanation-log/${id}`,
    method: 'get'
  });
}

export function runPosttreatmentCheckTest(data) {
  return request({
    url: '/shensuanzi-ai/posttreatment-check-test',
    method: 'post',
    data
  });
}

export function getPosttreatmentCheckTests(id, params = {}) {
  return request({
    url: `/fault-code-explanation-log/${id}/posttreatment-tests`,
    method: 'get',
    params
  });
}
